var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/fareCode.ts
import { summon } from "@silversea-ssc/functional-support";
import { fareKeys } from "@silversea-ssc/web-fares";
var FareCode = summon((F) => F.keysOf(fareKeys()));

// src/fareCodeMapping.ts
import { singleResFareFor as singleResFareForUnsafe } from "@silversea-ssc/web-fares";

// ../../node_modules/fp-ts/es6/function.js
var __spreadArray = function(to, from, pack) {
  if (pack || arguments.length === 2)
    for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
        if (!ar)
          ar = Array.prototype.slice.call(from, 0, i);
        ar[i] = from[i];
      }
    }
  return to.concat(ar || Array.prototype.slice.call(from));
};
function identity(a) {
  return a;
}
__name(identity, "identity");
function constant(a) {
  return function() {
    return a;
  };
}
__name(constant, "constant");
var constNull = /* @__PURE__ */ constant(null);
var constUndefined = /* @__PURE__ */ constant(void 0);
function flow(ab, bc, cd, de, ef, fg, gh, hi, ij) {
  switch (arguments.length) {
    case 1:
      return ab;
    case 2:
      return function() {
        return bc(ab.apply(this, arguments));
      };
    case 3:
      return function() {
        return cd(bc(ab.apply(this, arguments)));
      };
    case 4:
      return function() {
        return de(cd(bc(ab.apply(this, arguments))));
      };
    case 5:
      return function() {
        return ef(de(cd(bc(ab.apply(this, arguments)))));
      };
    case 6:
      return function() {
        return fg(ef(de(cd(bc(ab.apply(this, arguments))))));
      };
    case 7:
      return function() {
        return gh(fg(ef(de(cd(bc(ab.apply(this, arguments)))))));
      };
    case 8:
      return function() {
        return hi(gh(fg(ef(de(cd(bc(ab.apply(this, arguments))))))));
      };
    case 9:
      return function() {
        return ij(hi(gh(fg(ef(de(cd(bc(ab.apply(this, arguments)))))))));
      };
  }
  return;
}
__name(flow, "flow");
function pipe(a, ab, bc, cd, de, ef, fg, gh, hi) {
  switch (arguments.length) {
    case 1:
      return a;
    case 2:
      return ab(a);
    case 3:
      return bc(ab(a));
    case 4:
      return cd(bc(ab(a)));
    case 5:
      return de(cd(bc(ab(a))));
    case 6:
      return ef(de(cd(bc(ab(a)))));
    case 7:
      return fg(ef(de(cd(bc(ab(a))))));
    case 8:
      return gh(fg(ef(de(cd(bc(ab(a)))))));
    case 9:
      return hi(gh(fg(ef(de(cd(bc(ab(a))))))));
    default: {
      var ret = arguments[0];
      for (var i = 1; i < arguments.length; i++) {
        ret = arguments[i](ret);
      }
      return ret;
    }
  }
}
__name(pipe, "pipe");
var dual = /* @__PURE__ */ __name(function(arity, body) {
  var isDataFirst = typeof arity === "number" ? function(args) {
    return args.length >= arity;
  } : arity;
  return function() {
    var args = Array.from(arguments);
    if (isDataFirst(arguments)) {
      return body.apply(this, args);
    }
    return function(self) {
      return body.apply(void 0, __spreadArray([self], args, false));
    };
  };
}, "dual");

// ../../node_modules/fp-ts/es6/internal.js
var isSome = /* @__PURE__ */ __name(function(fa) {
  return fa._tag === "Some";
}, "isSome");
var none = { _tag: "None" };
var some = /* @__PURE__ */ __name(function(a) {
  return { _tag: "Some", value: a };
}, "some");
var isNonEmpty = /* @__PURE__ */ __name(function(as3) {
  return as3.length > 0;
}, "isNonEmpty");
var head = /* @__PURE__ */ __name(function(as3) {
  return as3[0];
}, "head");
var emptyReadonlyArray = [];
var emptyRecord = {};

// ../../node_modules/fp-ts/es6/Apply.js
function apFirst(A) {
  return function(second) {
    return function(first2) {
      return A.ap(A.map(first2, function(a) {
        return function() {
          return a;
        };
      }), second);
    };
  };
}
__name(apFirst, "apFirst");
function apSecond(A) {
  return function(second) {
    return function(first2) {
      return A.ap(A.map(first2, function() {
        return function(b) {
          return b;
        };
      }), second);
    };
  };
}
__name(apSecond, "apSecond");
function apS(F) {
  return function(name, fb) {
    return function(fa) {
      return F.ap(F.map(fa, function(a) {
        return function(b) {
          var _a;
          return Object.assign({}, a, (_a = {}, _a[name] = b, _a));
        };
      }), fb);
    };
  };
}
__name(apS, "apS");
function getApplySemigroup(F) {
  return function(S) {
    return {
      concat: function(first2, second) {
        return F.ap(F.map(first2, function(x) {
          return function(y) {
            return S.concat(x, y);
          };
        }), second);
      }
    };
  };
}
__name(getApplySemigroup, "getApplySemigroup");

// ../../node_modules/fp-ts/es6/Functor.js
function flap(F) {
  return function(a) {
    return function(fab) {
      return F.map(fab, function(f) {
        return f(a);
      });
    };
  };
}
__name(flap, "flap");
function bindTo(F) {
  return function(name) {
    return function(fa) {
      return F.map(fa, function(a) {
        var _a;
        return _a = {}, _a[name] = a, _a;
      });
    };
  };
}
__name(bindTo, "bindTo");
function let_(F) {
  return function(name, f) {
    return function(fa) {
      return F.map(fa, function(a) {
        var _a;
        return Object.assign({}, a, (_a = {}, _a[name] = f(a), _a));
      });
    };
  };
}
__name(let_, "let_");
function as(F) {
  return function(self, b) {
    return F.map(self, function() {
      return b;
    });
  };
}
__name(as, "as");
function asUnit(F) {
  var asM = as(F);
  return function(self) {
    return asM(self, void 0);
  };
}
__name(asUnit, "asUnit");

// ../../node_modules/fp-ts/es6/Applicative.js
function getApplicativeMonoid(F) {
  var f = getApplySemigroup(F);
  return function(M) {
    return {
      concat: f(M).concat,
      empty: F.of(M.empty)
    };
  };
}
__name(getApplicativeMonoid, "getApplicativeMonoid");

// ../../node_modules/fp-ts/es6/Chain.js
function tap(M) {
  return function(first2, f) {
    return M.chain(first2, function(a) {
      return M.map(f(a), function() {
        return a;
      });
    });
  };
}
__name(tap, "tap");
function bind(M) {
  return function(name, f) {
    return function(ma) {
      return M.chain(ma, function(a) {
        return M.map(f(a), function(b) {
          var _a;
          return Object.assign({}, a, (_a = {}, _a[name] = b, _a));
        });
      });
    };
  };
}
__name(bind, "bind");

// ../../node_modules/fp-ts/es6/FromEither.js
function fromEitherK(F) {
  return function(f) {
    return flow(f, F.fromEither);
  };
}
__name(fromEitherK, "fromEitherK");
function chainEitherK(F, M) {
  var fromEitherKF = fromEitherK(F);
  return function(f) {
    return function(ma) {
      return M.chain(ma, fromEitherKF(f));
    };
  };
}
__name(chainEitherK, "chainEitherK");
function tapEither(F, M) {
  var fromEither2 = fromEitherK(F);
  var tapM = tap(M);
  return function(self, f) {
    return tapM(self, fromEither2(f));
  };
}
__name(tapEither, "tapEither");

// ../../node_modules/fp-ts/es6/Semigroup.js
var constant2 = /* @__PURE__ */ __name(function(a) {
  return {
    concat: function() {
      return a;
    }
  };
}, "constant");
var first = /* @__PURE__ */ __name(function() {
  return { concat: identity };
}, "first");
var last = /* @__PURE__ */ __name(function() {
  return { concat: function(_, y) {
    return y;
  } };
}, "last");
var semigroupVoid = constant2(void 0);

// ../../node_modules/fp-ts/es6/Separated.js
var separated = /* @__PURE__ */ __name(function(left, right) {
  return { left, right };
}, "separated");

// ../../node_modules/fp-ts/es6/Witherable.js
function wiltDefault(T, C) {
  return function(F) {
    var traverseF = T.traverse(F);
    return function(wa, f) {
      return F.map(traverseF(wa, f), C.separate);
    };
  };
}
__name(wiltDefault, "wiltDefault");
function witherDefault(T, C) {
  return function(F) {
    var traverseF = T.traverse(F);
    return function(wa, f) {
      return F.map(traverseF(wa, f), C.compact);
    };
  };
}
__name(witherDefault, "witherDefault");

// ../../node_modules/fp-ts/es6/Zero.js
function guard(F, P) {
  return function(b) {
    return b ? P.of(void 0) : F.zero();
  };
}
__name(guard, "guard");

// ../../node_modules/fp-ts/es6/Option.js
var Option_exports = {};
__export(Option_exports, {
  Alt: () => Alt,
  Alternative: () => Alternative,
  ApT: () => ApT,
  Applicative: () => Applicative,
  Apply: () => Apply,
  Chain: () => Chain,
  Compactable: () => Compactable,
  Do: () => Do,
  Extend: () => Extend,
  Filterable: () => Filterable,
  Foldable: () => Foldable,
  FromEither: () => FromEither,
  Functor: () => Functor,
  Monad: () => Monad,
  MonadThrow: () => MonadThrow,
  Pointed: () => Pointed,
  Traversable: () => Traversable,
  URI: () => URI,
  Witherable: () => Witherable,
  Zero: () => Zero,
  alt: () => alt,
  altW: () => altW,
  ap: () => ap2,
  apFirst: () => apFirst2,
  apS: () => apS2,
  apSecond: () => apSecond2,
  as: () => as2,
  asUnit: () => asUnit2,
  bind: () => bind2,
  bindTo: () => bindTo2,
  chain: () => chain,
  chainEitherK: () => chainEitherK2,
  chainFirst: () => chainFirst,
  chainFirstEitherK: () => chainFirstEitherK,
  chainNullableK: () => chainNullableK,
  compact: () => compact,
  duplicate: () => duplicate,
  elem: () => elem,
  exists: () => exists,
  extend: () => extend,
  filter: () => filter,
  filterMap: () => filterMap,
  flap: () => flap2,
  flatMap: () => flatMap,
  flatten: () => flatten,
  fold: () => fold,
  foldMap: () => foldMap,
  foldW: () => foldW,
  fromEither: () => fromEither,
  fromEitherK: () => fromEitherK2,
  fromNullable: () => fromNullable,
  fromNullableK: () => fromNullableK,
  fromPredicate: () => fromPredicate,
  getApplyMonoid: () => getApplyMonoid,
  getApplySemigroup: () => getApplySemigroup2,
  getEq: () => getEq,
  getFirstMonoid: () => getFirstMonoid,
  getLastMonoid: () => getLastMonoid,
  getLeft: () => getLeft,
  getMonoid: () => getMonoid,
  getOrElse: () => getOrElse,
  getOrElseW: () => getOrElseW,
  getOrd: () => getOrd,
  getRefinement: () => getRefinement,
  getRight: () => getRight,
  getShow: () => getShow,
  guard: () => guard2,
  isNone: () => isNone,
  isSome: () => isSome2,
  let: () => let_2,
  map: () => map,
  mapNullable: () => mapNullable,
  match: () => match,
  matchW: () => matchW,
  none: () => none2,
  of: () => of,
  option: () => option,
  orElse: () => orElse,
  partition: () => partition,
  partitionMap: () => partitionMap,
  reduce: () => reduce,
  reduceRight: () => reduceRight,
  separate: () => separate,
  sequence: () => sequence,
  sequenceArray: () => sequenceArray,
  some: () => some2,
  tap: () => tap2,
  tapEither: () => tapEither2,
  throwError: () => throwError,
  toNullable: () => toNullable,
  toUndefined: () => toUndefined,
  traverse: () => traverse,
  traverseArray: () => traverseArray,
  traverseArrayWithIndex: () => traverseArrayWithIndex,
  traverseReadonlyArrayWithIndex: () => traverseReadonlyArrayWithIndex,
  traverseReadonlyNonEmptyArrayWithIndex: () => traverseReadonlyNonEmptyArrayWithIndex,
  tryCatch: () => tryCatch,
  tryCatchK: () => tryCatchK,
  wilt: () => wilt,
  wither: () => wither,
  zero: () => zero
});

// ../../node_modules/fp-ts/es6/Predicate.js
var not = /* @__PURE__ */ __name(function(predicate) {
  return function(a) {
    return !predicate(a);
  };
}, "not");

// ../../node_modules/fp-ts/es6/Option.js
var none2 = none;
var some2 = some;
function fromPredicate(predicate) {
  return function(a) {
    return predicate(a) ? some2(a) : none2;
  };
}
__name(fromPredicate, "fromPredicate");
var getLeft = /* @__PURE__ */ __name(function(ma) {
  return ma._tag === "Right" ? none2 : some2(ma.left);
}, "getLeft");
var getRight = /* @__PURE__ */ __name(function(ma) {
  return ma._tag === "Left" ? none2 : some2(ma.right);
}, "getRight");
var _map = /* @__PURE__ */ __name(function(fa, f) {
  return pipe(fa, map(f));
}, "_map");
var _ap = /* @__PURE__ */ __name(function(fab, fa) {
  return pipe(fab, ap2(fa));
}, "_ap");
var _reduce = /* @__PURE__ */ __name(function(fa, b, f) {
  return pipe(fa, reduce(b, f));
}, "_reduce");
var _foldMap = /* @__PURE__ */ __name(function(M) {
  var foldMapM = foldMap(M);
  return function(fa, f) {
    return pipe(fa, foldMapM(f));
  };
}, "_foldMap");
var _reduceRight = /* @__PURE__ */ __name(function(fa, b, f) {
  return pipe(fa, reduceRight(b, f));
}, "_reduceRight");
var _traverse = /* @__PURE__ */ __name(function(F) {
  var traverseF = traverse(F);
  return function(ta, f) {
    return pipe(ta, traverseF(f));
  };
}, "_traverse");
var _alt = /* @__PURE__ */ __name(function(fa, that) {
  return pipe(fa, alt(that));
}, "_alt");
var _filter = /* @__PURE__ */ __name(function(fa, predicate) {
  return pipe(fa, filter(predicate));
}, "_filter");
var _filterMap = /* @__PURE__ */ __name(function(fa, f) {
  return pipe(fa, filterMap(f));
}, "_filterMap");
var _extend = /* @__PURE__ */ __name(function(wa, f) {
  return pipe(wa, extend(f));
}, "_extend");
var _partition = /* @__PURE__ */ __name(function(fa, predicate) {
  return pipe(fa, partition(predicate));
}, "_partition");
var _partitionMap = /* @__PURE__ */ __name(function(fa, f) {
  return pipe(fa, partitionMap(f));
}, "_partitionMap");
var URI = "Option";
var getShow = /* @__PURE__ */ __name(function(S) {
  return {
    show: function(ma) {
      return isNone(ma) ? "none" : "some(".concat(S.show(ma.value), ")");
    }
  };
}, "getShow");
var getEq = /* @__PURE__ */ __name(function(E) {
  return {
    equals: function(x, y) {
      return x === y || (isNone(x) ? isNone(y) : isNone(y) ? false : E.equals(x.value, y.value));
    }
  };
}, "getEq");
var getOrd = /* @__PURE__ */ __name(function(O) {
  return {
    equals: getEq(O).equals,
    compare: function(x, y) {
      return x === y ? 0 : isSome2(x) ? isSome2(y) ? O.compare(x.value, y.value) : 1 : -1;
    }
  };
}, "getOrd");
var getMonoid = /* @__PURE__ */ __name(function(S) {
  return {
    concat: function(x, y) {
      return isNone(x) ? y : isNone(y) ? x : some2(S.concat(x.value, y.value));
    },
    empty: none2
  };
}, "getMonoid");
var map = /* @__PURE__ */ __name(function(f) {
  return function(fa) {
    return isNone(fa) ? none2 : some2(f(fa.value));
  };
}, "map");
var Functor = {
  URI,
  map: _map
};
var as2 = dual(2, as(Functor));
var asUnit2 = asUnit(Functor);
var of = some2;
var Pointed = {
  URI,
  of
};
var ap2 = /* @__PURE__ */ __name(function(fa) {
  return function(fab) {
    return isNone(fab) ? none2 : isNone(fa) ? none2 : some2(fab.value(fa.value));
  };
}, "ap");
var Apply = {
  URI,
  map: _map,
  ap: _ap
};
var Applicative = {
  URI,
  map: _map,
  ap: _ap,
  of
};
var flatMap = /* @__PURE__ */ dual(2, function(ma, f) {
  return isNone(ma) ? none2 : f(ma.value);
});
var Chain = {
  URI,
  map: _map,
  ap: _ap,
  chain: flatMap
};
var Monad = {
  URI,
  map: _map,
  ap: _ap,
  of,
  chain: flatMap
};
var reduce = /* @__PURE__ */ __name(function(b, f) {
  return function(fa) {
    return isNone(fa) ? b : f(b, fa.value);
  };
}, "reduce");
var foldMap = /* @__PURE__ */ __name(function(M) {
  return function(f) {
    return function(fa) {
      return isNone(fa) ? M.empty : f(fa.value);
    };
  };
}, "foldMap");
var reduceRight = /* @__PURE__ */ __name(function(b, f) {
  return function(fa) {
    return isNone(fa) ? b : f(fa.value, b);
  };
}, "reduceRight");
var Foldable = {
  URI,
  reduce: _reduce,
  foldMap: _foldMap,
  reduceRight: _reduceRight
};
var orElse = dual(2, function(self, that) {
  return isNone(self) ? that() : self;
});
var altW = orElse;
var alt = orElse;
var Alt = {
  URI,
  map: _map,
  alt: _alt
};
var zero = /* @__PURE__ */ __name(function() {
  return none2;
}, "zero");
var Zero = {
  URI,
  zero
};
var guard2 = /* @__PURE__ */ guard(Zero, Pointed);
var Alternative = {
  URI,
  map: _map,
  ap: _ap,
  of,
  alt: _alt,
  zero
};
var extend = /* @__PURE__ */ __name(function(f) {
  return function(wa) {
    return isNone(wa) ? none2 : some2(f(wa));
  };
}, "extend");
var Extend = {
  URI,
  map: _map,
  extend: _extend
};
var compact = /* @__PURE__ */ flatMap(identity);
var defaultSeparated = /* @__PURE__ */ separated(none2, none2);
var separate = /* @__PURE__ */ __name(function(ma) {
  return isNone(ma) ? defaultSeparated : separated(getLeft(ma.value), getRight(ma.value));
}, "separate");
var Compactable = {
  URI,
  compact,
  separate
};
var filter = /* @__PURE__ */ __name(function(predicate) {
  return function(fa) {
    return isNone(fa) ? none2 : predicate(fa.value) ? fa : none2;
  };
}, "filter");
var filterMap = /* @__PURE__ */ __name(function(f) {
  return function(fa) {
    return isNone(fa) ? none2 : f(fa.value);
  };
}, "filterMap");
var partition = /* @__PURE__ */ __name(function(predicate) {
  return function(fa) {
    return separated(_filter(fa, not(predicate)), _filter(fa, predicate));
  };
}, "partition");
var partitionMap = /* @__PURE__ */ __name(function(f) {
  return flow(map(f), separate);
}, "partitionMap");
var Filterable = {
  URI,
  map: _map,
  compact,
  separate,
  filter: _filter,
  filterMap: _filterMap,
  partition: _partition,
  partitionMap: _partitionMap
};
var traverse = /* @__PURE__ */ __name(function(F) {
  return function(f) {
    return function(ta) {
      return isNone(ta) ? F.of(none2) : F.map(f(ta.value), some2);
    };
  };
}, "traverse");
var sequence = /* @__PURE__ */ __name(function(F) {
  return function(ta) {
    return isNone(ta) ? F.of(none2) : F.map(ta.value, some2);
  };
}, "sequence");
var Traversable = {
  URI,
  map: _map,
  reduce: _reduce,
  foldMap: _foldMap,
  reduceRight: _reduceRight,
  traverse: _traverse,
  sequence
};
var _wither = /* @__PURE__ */ witherDefault(Traversable, Compactable);
var _wilt = /* @__PURE__ */ wiltDefault(Traversable, Compactable);
var wither = /* @__PURE__ */ __name(function(F) {
  var _witherF = _wither(F);
  return function(f) {
    return function(fa) {
      return _witherF(fa, f);
    };
  };
}, "wither");
var wilt = /* @__PURE__ */ __name(function(F) {
  var _wiltF = _wilt(F);
  return function(f) {
    return function(fa) {
      return _wiltF(fa, f);
    };
  };
}, "wilt");
var Witherable = {
  URI,
  map: _map,
  reduce: _reduce,
  foldMap: _foldMap,
  reduceRight: _reduceRight,
  traverse: _traverse,
  sequence,
  compact,
  separate,
  filter: _filter,
  filterMap: _filterMap,
  partition: _partition,
  partitionMap: _partitionMap,
  wither: _wither,
  wilt: _wilt
};
var throwError = /* @__PURE__ */ __name(function() {
  return none2;
}, "throwError");
var MonadThrow = {
  URI,
  map: _map,
  ap: _ap,
  of,
  chain: flatMap,
  throwError
};
var fromEither = getRight;
var FromEither = {
  URI,
  fromEither
};
var isSome2 = isSome;
var isNone = /* @__PURE__ */ __name(function(fa) {
  return fa._tag === "None";
}, "isNone");
var matchW = /* @__PURE__ */ __name(function(onNone, onSome) {
  return function(ma) {
    return isNone(ma) ? onNone() : onSome(ma.value);
  };
}, "matchW");
var foldW = matchW;
var match = matchW;
var fold = match;
var getOrElseW = /* @__PURE__ */ __name(function(onNone) {
  return function(ma) {
    return isNone(ma) ? onNone() : ma.value;
  };
}, "getOrElseW");
var getOrElse = getOrElseW;
var flap2 = /* @__PURE__ */ flap(Functor);
var apFirst2 = /* @__PURE__ */ apFirst(Apply);
var apSecond2 = /* @__PURE__ */ apSecond(Apply);
var flatten = compact;
var tap2 = /* @__PURE__ */ dual(2, tap(Chain));
var tapEither2 = /* @__PURE__ */ dual(2, tapEither(FromEither, Chain));
var duplicate = /* @__PURE__ */ extend(identity);
var fromEitherK2 = /* @__PURE__ */ fromEitherK(FromEither);
var chainEitherK2 = /* @__PURE__ */ chainEitherK(FromEither, Chain);
var chainFirstEitherK = tapEither2;
var fromNullable = /* @__PURE__ */ __name(function(a) {
  return a == null ? none2 : some2(a);
}, "fromNullable");
var tryCatch = /* @__PURE__ */ __name(function(f) {
  try {
    return some2(f());
  } catch (e) {
    return none2;
  }
}, "tryCatch");
var tryCatchK = /* @__PURE__ */ __name(function(f) {
  return function() {
    var a = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      a[_i] = arguments[_i];
    }
    return tryCatch(function() {
      return f.apply(void 0, a);
    });
  };
}, "tryCatchK");
var fromNullableK = /* @__PURE__ */ __name(function(f) {
  return flow(f, fromNullable);
}, "fromNullableK");
var chainNullableK = /* @__PURE__ */ __name(function(f) {
  return function(ma) {
    return isNone(ma) ? none2 : fromNullable(f(ma.value));
  };
}, "chainNullableK");
var toNullable = /* @__PURE__ */ match(constNull, identity);
var toUndefined = /* @__PURE__ */ match(constUndefined, identity);
function elem(E) {
  return function(a, ma) {
    if (ma === void 0) {
      var elemE_1 = elem(E);
      return function(ma2) {
        return elemE_1(a, ma2);
      };
    }
    return isNone(ma) ? false : E.equals(a, ma.value);
  };
}
__name(elem, "elem");
var exists = /* @__PURE__ */ __name(function(predicate) {
  return function(ma) {
    return isNone(ma) ? false : predicate(ma.value);
  };
}, "exists");
var Do = /* @__PURE__ */ of(emptyRecord);
var bindTo2 = /* @__PURE__ */ bindTo(Functor);
var let_2 = /* @__PURE__ */ let_(Functor);
var bind2 = /* @__PURE__ */ bind(Chain);
var apS2 = /* @__PURE__ */ apS(Apply);
var ApT = /* @__PURE__ */ of(emptyReadonlyArray);
var traverseReadonlyNonEmptyArrayWithIndex = /* @__PURE__ */ __name(function(f) {
  return function(as3) {
    var o = f(0, head(as3));
    if (isNone(o)) {
      return none2;
    }
    var out = [o.value];
    for (var i = 1; i < as3.length; i++) {
      var o_1 = f(i, as3[i]);
      if (isNone(o_1)) {
        return none2;
      }
      out.push(o_1.value);
    }
    return some2(out);
  };
}, "traverseReadonlyNonEmptyArrayWithIndex");
var traverseReadonlyArrayWithIndex = /* @__PURE__ */ __name(function(f) {
  var g = traverseReadonlyNonEmptyArrayWithIndex(f);
  return function(as3) {
    return isNonEmpty(as3) ? g(as3) : ApT;
  };
}, "traverseReadonlyArrayWithIndex");
var traverseArrayWithIndex = traverseReadonlyArrayWithIndex;
var traverseArray = /* @__PURE__ */ __name(function(f) {
  return traverseReadonlyArrayWithIndex(function(_, a) {
    return f(a);
  });
}, "traverseArray");
var sequenceArray = /* @__PURE__ */ traverseArray(identity);
var chain = flatMap;
var chainFirst = tap2;
function getRefinement(getOption) {
  return function(a) {
    return isSome2(getOption(a));
  };
}
__name(getRefinement, "getRefinement");
var mapNullable = chainNullableK;
var option = {
  URI,
  map: _map,
  of,
  ap: _ap,
  chain: flatMap,
  reduce: _reduce,
  foldMap: _foldMap,
  reduceRight: _reduceRight,
  traverse: _traverse,
  sequence,
  zero,
  alt: _alt,
  extend: _extend,
  compact,
  separate,
  filter: _filter,
  filterMap: _filterMap,
  partition: _partition,
  partitionMap: _partitionMap,
  wither: _wither,
  wilt: _wilt,
  throwError
};
var getApplySemigroup2 = /* @__PURE__ */ getApplySemigroup(Apply);
var getApplyMonoid = /* @__PURE__ */ getApplicativeMonoid(Applicative);
var getFirstMonoid = /* @__PURE__ */ __name(function() {
  return getMonoid(first());
}, "getFirstMonoid");
var getLastMonoid = /* @__PURE__ */ __name(function() {
  return getMonoid(last());
}, "getLastMonoid");

// src/fareCodeMapping.ts
var singleResFareFor = Option_exports.fromNullableK(singleResFareForUnsafe);
export {
  FareCode,
  singleResFareFor
};
//# sourceMappingURL=index.js.map
